<style scoped lang="scss" type="text/scss">
    .text-container {
        max-height: 35rem;
        overflow: scroll;
        margin: 0 110px 1rem;

        h2 {
            margin-bottom: 1rem;
        }

        p {
            margin: .15rem 0;
        }
    }
</style>

<template>

    <div class="text-container" ref="globalTermsTextContainer">
        <h2>注意事项</h2>
        <p>1. 申请提交后，需要等待管理员的审批处理。</p>
        <p>2. 待审批通过后，参赛申请流程完成。</p>
        <p>3. 申请成功后，参赛队长将负责该届成员的管理及参赛信息的填报。</p>
        <p>4. 申请成功后，必须完成全部必选的填报项，才能进行最终确认。</p>
        <p>5. 确认填报后，将无法继续修改本届参赛信息。请在最终确认前认真核对您填写的信息完整、准确，谨慎操作。</p>
        <p>6. 到达填报截至时间时，未手动进行最终确认的队伍会自动完成确认。</p>
        <p>7. 到达填报截至时间缺未完成全部必填项的参赛队，可能会在赛事奖励等事宜中受到影响。</p>
        <p>8. 最终确认后，系统会将本届填报信息通过邮件发送至领队指导教师、学生队长，并抄送组委会，以作为证书等奖项凭证。</p>
        <p>9. 请确认领队指导教师、学生队长已完善个人邮箱信息。</p>
    </div>
</template>

<script>
    export default {
        name: '',
        components: {},
        watch: {},
        data () {
            return {};
        }
    };
</script>
